// Importing this module installs a filter over
// `customElements.define` that drops a name the registry
// already holds, and that install is a side effect of the
// import rather than a function you call. It has to be: a
// module's static imports are evaluated, in source order,
// before a single line of its own body runs, so importing
// this ahead of a package is the only way to get in front
// of the `define` calls that package makes at module
// scope.
//
// `shared/cally.js` is the only importer, and it takes the
// filter back off as soon as cally has been evaluated, so
// it is never in place for anyone else's registration.
//
// A first registration is never skipped: the check reads
// the live registry, which answers `undefined` for a name
// nobody has defined.
const registry = window.customElements;
const nativeDefine = registry.define;

function defineUnlessRegistered(name, constructor, options) {
  if (registry.get(name)) return;

  return nativeDefine.call(this, name, constructor, options);
}

registry.define = defineUnlessRegistered;

export function restoreCustomElementDefine() {
  // Only if `define` is still ours. Sentry's session replay
  // patches this same method when recording starts (rrweb's
  // custom element observer, and it starts more than once
  // per document), so a blind assignment could drop someone
  // else's wrapper off the chain.
  if (registry.define !== defineUnlessRegistered) return;

  registry.define = nativeDefine;
}
